import { mdiShieldPlus } from '@mdi/js';
import { Column, Icon, Margin, Row, SpinnerContainer } from '@upgrade/react-components';
import React from 'react';
import { reverseFocusFromColor } from '../../utils/focus-color';
import { toHtmlSanitize } from '../../utils/remark-html';
import Fluid from '../Fluid';
import Banner from '../common/Banner';
import Highlights from '../common/Highlights';
import { Heading } from '../common/TypographyPublicSite';
import { StyledCTAButton, Hero as StyledHero, StyledLineHeader } from '../common/styles';
import { StyledInsuranceIcon, StyledInsuranceNotice, StyledInsuranceNoticeText } from '../rewards-checking/styles';
import { HeroImageContainer, StyledHighlightsContainer, StyledImg } from '../upgrade-card/styles';
import AccountEmailForm from './AccountEmailForm';
import * as Styles from './styles';

const Hero = ({
  hero: {
    bulletColor,
    ctaLinkUrl,
    caption,
    insuranceText,
    titleColor = 'actionableHover',
    ctaButtonName,
    ctaButtonText,
    ctaButtonAriaLabel,
    fontColor,
    showWhiteActionButton = false,
    backgroundColor,
    title,
    ctaSticky,
    hideImageOnMobile,
    image,
    imageWidth,
    imageHeight,
    imageWithTopMargin,
    imageWithLeftMargin,
    bulletType,
    highlights = []
  } = {},
  banner,
  location,
  depositUrl,
  isReady,
  captureEmailExperiment
}) => {
  if (!isReady) {
    return (
      <SpinnerContainer active>
        <div style={{ height: 500 }} />
      </SpinnerContainer>
    );
  }

  const CustomHero = captureEmailExperiment ? Styles.HeroExperiment : StyledHero;

  return (
    <CustomHero backgroundColor={backgroundColor}>
      <Fluid>
        <Row gutter="large">
          <Column xs={12}>
            <Row xsVerticalAlign="middle">
              <Column xs={12} md={6}>
                <Margin bottom="md">
                  {caption ? <StyledLineHeader data-color={fontColor}>{caption}</StyledLineHeader> : null}
                  <Heading
                    as="h1"
                    color={titleColor}
                    dangerouslySetInnerHTML={{ __html: toHtmlSanitize(title, { removeWrappingPTag: true }) }}
                    size="md"
                  />
                </Margin>
                {highlights && (
                  <StyledHighlightsContainer data-color={fontColor}>
                    <Highlights {...{ highlights }} icon={bulletType} iconColor={bulletColor} color={fontColor} />
                  </StyledHighlightsContainer>
                )}
                {ctaButtonText && ctaLinkUrl && (
                  <Margin top={{ xs: 'md', md: '2xl' }}>
                    <Row xsVerticalAlign="middle">
                      <Column xs={12} md={9}>
                        {captureEmailExperiment ? (
                          <AccountEmailForm {...{ ctaButtonName, ctaButtonAriaLabel, location }} />
                        ) : (
                          <StyledCTAButton
                            {...{
                              ariaLabel: ctaButtonAriaLabel,
                              ctaButtonText,
                              linkUrl: depositUrl,
                              emphasis: !showWhiteActionButton ? 'primary' : 'secondary',
                              reverseFocus: reverseFocusFromColor(fontColor),
                              buttonProps: {
                                'data-auto': ctaButtonName
                              },
                              sticky: ctaSticky
                            }}
                          />
                        )}
                      </Column>

                      {banner ? (
                        <Column xs={12} md={9} className="hidden visible-sm">
                          <Margin top="md">
                            <Banner {...banner} />
                          </Margin>
                        </Column>
                      ) : null}

                      {insuranceText && (
                        <Column xs={12} md={9}>
                          <StyledInsuranceNotice>
                            <StyledInsuranceIcon>
                              <Icon color="contentReverse" icon={mdiShieldPlus} size="1rem" />
                            </StyledInsuranceIcon>
                            <StyledInsuranceNoticeText data-color={fontColor}>
                              {insuranceText}
                            </StyledInsuranceNoticeText>
                          </StyledInsuranceNotice>
                        </Column>
                      )}
                    </Row>
                  </Margin>
                )}
              </Column>

              <Column xs={12} md={6} xsHorizontalAlign="center">
                <HeroImageContainer>
                  <StyledImg
                    src={image}
                    width={imageWidth}
                    height={imageHeight}
                    className="hidden visible-sm"
                    withMargin={imageWithTopMargin}
                    withLeftMargin={imageWithLeftMargin}
                  />
                </HeroImageContainer>
              </Column>
            </Row>
          </Column>
        </Row>
      </Fluid>
      {banner ? (
        <Margin top="md">
          <Banner {...banner} className="hidden-sm" />
        </Margin>
      ) : null}
      {!hideImageOnMobile ? (
        <StyledImg src={image} width={imageWidth} height={imageHeight} className="hidden-sm" />
      ) : null}
    </CustomHero>
  );
};

export default Hero;
